"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.concatBuckyLabel = concatBuckyLabel;
exports.createPayload = createPayload;
exports.buckyQueryData = exports.submitPath = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _enviro = require("enviro");

var envPrefix = (0, _enviro.getShort)();
var urlSuffix = envPrefix === 'qa' ? 'qa' : '';
var submitPath = "https://app.hubspot" + urlSuffix + ".com/bucky/v2/send";
exports.submitPath = submitPath;
var buckyQueryData = {
  monitoringType: 'js-library'
};
exports.buckyQueryData = buckyQueryData;

function concatBuckyLabel() {
  for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
    parts[_key] = arguments[_key];
  }

  if (!parts.length) {
    return 'jslib';
  }

  return parts.join('.');
}

function createPayload(product, location) {
  var labelPrefix = concatBuckyLabel(product, location, (0, _enviro.getShort)()); // signal fx syntax - simply keeps track of overall errors.

  var payload = (0, _defineProperty2.default)({}, labelPrefix + ".caughtErrors", '1|c');
  return payload;
}